const actionTypeIdentifier = '3cfd4d1c-f56a-488b-a095-85a59b5950c8';
export const getFollowUpDetails  = `DISPUTE-GET-FOLLOWUP-DETAILS-${actionTypeIdentifier}`;
export const getFollowUpDetailsByType = `DISPUTE-GET-FOLLOWUP-DETAILS-BY-TYPE-${actionTypeIdentifier}`;
export const setFollowUpError = `DISPUTE-SET-FOLLOWUP-ERROR-${actionTypeIdentifier}`
export const disputeFollowUpModel = {
    disputeId: 0,
    type:'',
    details:'',
    followUpDate:null
}